import apiClient from '@/plugins/apiClientDrive'


export default {
    namespaced: true,
    state:{
        errors: null,
        message: null,
        single: null,
        types: [
            {name:"identity", val: "I"},
            {name:"passport", val: "P"},
            {name:"credit-card", val: "C"},
            {name:"driver-license", val: "L"},
        ],
        list: null,
    },
    getters:{
        errors: state => state.errors,
        message: state => state.message,
        single: state => state.single,
        list: state => state.list,
        types: state => state.types,
    },
    mutations:{
        error(state, err) {
            state.message = err.response.data.message;
            state.errors = err.response.data.errors;
        },
        setList(state, data) {
            state.list = data;
        },
        setSingle(state, data) {
            state.single = data;
        },
        reset(state){
            state.errors = {}
            state.message = null
            state.success = null
        },
    },
    actions:{
        resetErrors({commit}){
            commit('reset')
        },
        getList({commit}){
            return new Promise((resolve, reject) => {
                apiClient.get("users/me/documents").then(resp => {
                        commit('setList', resp.data);
                        resolve(resp);
                    })
                    .catch(err => {
                        commit('error', err);
                        reject(err);
                    });
            })
        },
        createSingle({commit},document){
            return new Promise((resolve, reject) => {
                apiClient.post("users/me/documents",document).then(resp => {
                        commit('setSingle', resp.data);
                        resolve(resp);
                    })
                    .catch(err => {
                        commit('error', err);
                        reject(err);
                    });
            })
        },
        // getSingle({commit},document){
        //     return new Promise((resolve, reject) => {
        //         console.log('GET USER DOCUMENTS')
        //         apiClient.get("users/me/documents/"+document.id).then(resp => {
        //                 commit('setSingle', resp.data);
        //                 resolve(resp);
        //             })
        //             .catch(err => {
        //                 console.log('get car brands error ', err)
        //                 commit('error', err);
        //                 reject(err);
        //             });
        //     })
        // },
        // deleteSingle({commit},document){
        //     return new Promise((resolve, reject) => {
        //         console.log('GET USER DOCUMENTS')
        //         apiClient.delete("users/me/documents/"+document.id).then(resp => {
        //                 commit('setSingle', null);
        //                 resolve(resp);
        //             })
        //             .catch(err => {
        //                 console.log('get car brands error ', err)
        //                 commit('error', err);
        //                 reject(err);
        //             });
        //     })
        // },
        // updateSingle({commit},document){
        //     return new Promise((resolve, reject) => {
        //         console.log('GET USER DOCUMENTS')
        //         apiClient.patch("users/me/documents/"+document.id, document).then(resp => {
        //                 commit('setSingle', resp.data);
        //                 resolve(resp);
        //             })
        //             .catch(err => {
        //                 console.log('get car brands error ', err)
        //                 commit('error', err);
        //                 reject(err);
        //             });
        //     })
        // },
    },
}